import React from 'react';
import './Privacy.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import PrivacyContent from '../../components/PrivacyContent';
import { useState } from 'react';
import AppNavBar from '../../helper/appbar';

const Privacy = () => {
    const [isActive, setIsActive] = useState(1);

    const handleClick = (e) => {
        setIsActive(e);
    };

    const freeSignUp = () => window.open("http://app.gokardinal.com/onboarding", "_blank");
    const freeSignIn = () => window.open("http://app.gokardinal.com/login", "_blank");

    return (
        <div>
            <AppNavBar navType={'_light'} />
            <section className='privacy-head'>
                <div className='privacy-background'>
                    <h1>
                        Privacy
                    </h1>
                </div>
            </section>

            <Container>
                <div className='tabbar-head'>
                    <p className={isActive === 1 ? 'tabActive' : ""} onClick={() => handleClick(1)}>Terms Of Service</p>
                    <p className={isActive === 2 ? 'tabActive' : ""} onClick={() => handleClick(2)}>Security</p>
                    <p className={isActive === 3 ? 'tabActive' : ""} onClick={() => handleClick(3)}>Privacy Policy</p>
                </div>
                <PrivacyContent page={isActive} />
            </Container>

            <div className='gradientRectangle'>
                <p>
                    {"Experience business travel made for"}<br></br>{"businesses like yours."}
                </p>
                <div>
                    <input placeholder='Your work email' />
                    <button className='buttonFull' onClick={freeSignUp}>Sign up for free</button>
                    <button className='buttonSmall' onClick={freeSignIn}>Sign up</button>
                </div>
            </div>
        </div>
    );
};

export default Privacy;
